import styled from "styled-components";

export const Wrapper = styled.div`
  background: linear-gradient(90deg, #0090d1, #00c3ea);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Card = styled.div`
  text-align: center;
  margin: auto;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  width: 28.75rem;
  min-width: 20rem;
  border-radius: 4px;
  padding: 0 2rem 1rem 2rem;
  background-color: white;
  min-height: 330px;

  .title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;
  }

  .logo {
    width: 100%;
  }

  .margin-top {
    margin-top: 1rem;
  }

  .login-link {
    margin-top: 1rem;
    color: rgb(0, 144, 209);
    cursor: pointer;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .loading-container {
    margin-top: 2rem;
  }

  .login-form-button {
    margin-top: 1.5rem;
    height: 40px;
    width: 100%;
    margin-bottom: 0.5rem;
  }

  .error-message {
    color: red;
    font-size: 14px;
    font-family: "Roboto";
    line-height: 18px;
  }
  .success-message {
    color: green;
    font-size: 14px;
    font-family: "Roboto";
    line-height: 18px;
  }

  .success-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 4rem;
    color: green;
    font-size: 1rem;
    font-family: "Roboto";
  }

  .login-link {
    margin-top: 1rem;
    color: rgb(0, 144, 209);
    cursor: pointer;
    font-family: "Roboto";
    text-decoration: none;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .info-icon {
    margin-left: 0.5rem;
  }
`;
